import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectWithCheckboxRadioOption, SelectWithCheckboxRadioValue } from '../services/multi-facility.model';

/**
 * Select with checkbox or radio button
 * ====================================
 * 
 * Params:
 *  hint: string
 *      - to show when don't have any selected options
 *  isMultiple: boolean
 *      - true: will display checkboxes and radio button display for others 
 *  options: SelectWithCheckboxRadioOption[]
 *      - An array of options with "SelectWithCheckboxRadioOption" format.
 *  onChange: function
 *      - When a change happen on component, this function will trigger.
 * 
 * Template:
      <app-select-with-checkbox-radio
        hint="Select your subsidery facilities"
        [isMultiple]="true"
        [options]="...selectableOptions"
        [onChange]="onChangeDoneFunction($event)">
      <app-select-with-checkbox-radio>
 * 
 * 
 * Used In:
 *    1. SetLevelComponent
 */

@Component({
  selector: 'app-select-with-checkbox-radio',
  templateUrl: './select-with-checkbox-radio.component.html',
  styleUrls: ['./select-with-checkbox-radio.component.scss'],
})
export class SelectWithCheckboxRadioComponent implements OnInit {
  isOpen: boolean = false;
  selectedValue: string = '';
  keyword: string = '';
  options: SelectWithCheckboxRadioOption[] = [];
  @Input() hint: string;
  @Input() isMultiple: boolean = false;
  @Input('options') _options: SelectWithCheckboxRadioOption[] = [];
  @Output() onChange: EventEmitter<SelectWithCheckboxRadioValue> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this.options = this._options;
  }

  close(): void {
    this.isOpen = false;
  }

  open(): void {
    this.isOpen = !this.isOpen ;
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  select(option: SelectWithCheckboxRadioOption) {
    if (this.isMultiple) {
      option.checked = !option.checked;
    } else {
      this.options.forEach((item) => {
        if (item.id == option.id) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
    }

    // update to parent
    let response: SelectWithCheckboxRadioValue = {
      isMultiple: this.isMultiple,
      selected: this._options.filter((item) => item.checked),
    };
    this.onChange.emit(response);

    // update lable
    let _selectedValue: string[] = [];
    response.selected.forEach((item) => {
      _selectedValue.push(item.label);
    });
    this.selectedValue = _selectedValue.join(', ');
  }

  onKeywordChange(value: string) {
    this.options = this._options.filter((item) => {
      return (item.label.toLowerCase()).includes(value.toLowerCase());
    });
  }
}
